import request from '@/helpers/customAxios'
// import axios from "axios";
export async function getUserInfo(): Promise<any> {
    return request.get('/api/getUserInfo')
}
export async function logout(): Promise<any> {
    return request.get('/api/logout')
}
export interface IPageNation {
    current: number
    size: number
}
export interface Notify {
    message?: 'string'
    reminder?: 'string'
    users: any[]
}
export interface ShareFileInfo {
    createTime: string
    createUserId: string
    expireTime: string
    file: ShareFileItem
    fileId: string
    fileSize: number
    id: string
    isFile: boolean
    shareUserList: string[]
    surplusMillis: number
    type: number
    updateTime: string
    url: string
    shareIdentify?: string
    notify?: Notify
}
export interface ShareFileItem {
    chunkNum: number
    compress?: boolean
    createTime: number
    createUser: string
    id: string
    identifier: string
    isFile: boolean
    level: number
    name: string
    number?: number
    oldId?: string
    parentId: string
    path: string
    powers?: number[]
    size: number
    sourceId?: string
    topId: string
    type: string
    unzip?: boolean
    updateTime: number
    updateUser: string
    userId?: string
}

export interface NoLogFileInfo {
    // 外部无登录文件信息
    userId?: string
    userName?: string
    file?: ShareFileItem
    dir: ShareFileItem
    // extranet": true,
    expire: number
    notify?: Notify
}
export async function getShareFileInfo(params: {
    id: string
}): Promise<{
        code: number
        data: ShareFileInfo
        desc: string
    }> {
    return request.get('/api/getShareFileInfo', { params })
}
export async function getFileInfoByUuid(params: {
    id: string
}): Promise<{
        code: number
        data?: NoLogFileInfo
        desc: string
    }> {
    const { id } = params
    const commonErr = {
        code: -1,
        desc: '缺少参数',
    }
    if (!id) {
        return commonErr
    }
    let res
    try {
        res = await request.get(`/common/query/${id}`)
    } catch (e) {
        res = commonErr
        res.desc = '网络出错'
    }
    return res
}

export async function notifyUser(
    id: string,
    type?: 'inner' | 'out'
): Promise<{
        code: number
        data?: any
        desc: string
    }> {
    const commonErr = {
        code: -1,
        desc: '缺少参数',
    }
    if (!id) {
        return commonErr
    }
    let res
    try {
        const url = type === 'inner' ? `/api/notify?shareIdentify=${id}` : `/common/notify/${id}`
        res = await request.get(url)
    } catch (e) {
        res = commonErr
        res.desc = '网络出错'
    }
    return res
}
